import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_URL } from '../config/api';
import { buildCustomerReceiptHtml, buildRepairReceiptHtml, buildRepairPaymentReceiptHtml } from '../utils/repairReceiptHtml';

// Gizli fiş önizleme sayfası — /repairs/:token
// Tamirat fiş numarası girilince Müşteri Teslim Fişi ve Tamirat Fişi tasarımını
// yan yana gösterir. Yazıcıya GÖNDERMEZ (autoPrint=false), sadece ekranda önizleme.
function ReceiptPreview() {
  const { token } = useParams();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [customerHtml, setCustomerHtml] = useState('');
  const [repairHtml, setRepairHtml] = useState('');
  const [paymentHtml, setPaymentHtml] = useState('');
  const [shownCode, setShownCode] = useState('');

  const handleShow = async (e) => {
    e.preventDefault();
    setError('');
    setCustomerHtml('');
    setRepairHtml('');
    setPaymentHtml('');
    const c = code.trim();
    if (!/^\d{6}$/.test(c)) {
      setError('Lütfen 6 haneli tamirat fiş numarasını girin.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/public/repair-receipt/${token}/${c}`);
      const data = await res.json();
      if (!res.ok || !data.success) {
        setError(data.error || 'Bu numara ile kayıt bulunamadı.');
        setLoading(false);
        return;
      }
      const repair = data.repair;
      const storeId = Number(repair.store_id) || 1;

      // Müşteri fişi için QR kodu çek (tamirat fişinde QR yok)
      let qrCodeData = null;
      try {
        const qrRes = await fetch(`${API_URL}/public/repair-qr/${c}`);
        const qrJson = await qrRes.json();
        if (qrJson.success) qrCodeData = qrJson.qrCode;
      } catch (err) {
        // QR alınamazsa fiş yine de gösterilir
      }

      setCustomerHtml(buildCustomerReceiptHtml(repair, { storeId, qrCodeData, autoPrint: false }));
      setRepairHtml(buildRepairReceiptHtml(repair, { storeId, autoPrint: false }));
      setPaymentHtml(buildRepairPaymentReceiptHtml(repair, { storeId, autoPrint: false }));
      setShownCode(c);
    } catch (err) {
      setError('Bir hata oluştu. Lütfen tekrar deneyin.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9', padding: '24px 16px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ maxWidth: 760, margin: '0 auto 20px auto' }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: '#0f172a', margin: '0 0 4px 0' }}>Fiş Önizleme</h1>
        <p style={{ fontSize: 13, color: '#64748b', margin: '0 0 16px 0' }}>
          Tamirat fiş numarasını girin; Müşteri Teslim Fişi ve Tamirat Fişi tasarımını yazdırmadan görün.
        </p>
        <form onSubmit={handleShow} style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input
            type="text"
            inputMode="numeric"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            placeholder="Örn: 000123"
            style={{
              flex: '1 1 200px', padding: '10px 12px', fontSize: 15, borderRadius: 8,
              border: '1px solid #cbd5e1', outline: 'none', letterSpacing: 2,
            }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '10px 20px', fontSize: 15, fontWeight: 600, borderRadius: 8, border: 'none',
              background: loading ? '#94a3b8' : '#2563eb', color: '#fff', cursor: loading ? 'default' : 'pointer',
            }}
          >
            {loading ? 'Yükleniyor...' : 'Göster'}
          </button>
        </form>
        {error && (
          <div style={{ marginTop: 12, color: '#b91c1c', fontSize: 14, fontWeight: 600 }}>{error}</div>
        )}
      </div>

      {(customerHtml || repairHtml || paymentHtml) && (
        <div style={{
          display: 'flex', gap: 24, justifyContent: 'center', alignItems: 'flex-start', flexWrap: 'wrap',
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#334155', marginBottom: 8 }}>
              Müşteri Teslim Fişi {shownCode && `— ${shownCode}`}
            </div>
            <iframe
              title="Müşteri Teslim Fişi"
              srcDoc={customerHtml}
              style={{ width: 340, height: 1000, border: '1px solid #cbd5e1', borderRadius: 6, background: '#fff' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#334155', marginBottom: 8 }}>
              Tamirat Fişi {shownCode && `— ${shownCode}`}
            </div>
            <iframe
              title="Tamirat Fişi"
              srcDoc={repairHtml}
              style={{ width: 340, height: 1000, border: '1px solid #cbd5e1', borderRadius: 6, background: '#fff' }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#334155', marginBottom: 8 }}>
              Tamirat Tahsilat Fişi {shownCode && `— ${shownCode}`}
            </div>
            <iframe
              title="Tamirat Tahsilat Fişi"
              srcDoc={paymentHtml}
              style={{ width: 340, height: 1000, border: '1px solid #cbd5e1', borderRadius: 6, background: '#fff' }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ReceiptPreview;
